
export default {
  state: {
    lang: 2,
  },
  mutations: {
    SET_LANG(state, value) {
      state.lang = value;
    },
  },
  actions: {
    
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/message.js